import { render, staticRenderFns } from "./BuyList.vue?vue&type=template&id=14e3e8db&scoped=true&"
import script from "./BuyList.vue?vue&type=script&lang=js&"
export * from "./BuyList.vue?vue&type=script&lang=js&"
import style0 from "./BuyList.vue?vue&type=style&index=0&id=14e3e8db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e3e8db",
  null
  
)

export default component.exports